// src/pages/WorkboardPage.tsx (renamed from TasksPage)
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ModernWorkboard from '../components/ModernWorkboard';
import PageWrapper from '../components/PageWrapper';
import PageLayout from '../components/PageLayout';
import { usePlanRestrictions } from '../hooks/usePlanRestrictions';

const WorkboardPage: React.FC = () => {
  const navigate = useNavigate();
  const { restrictions, checkAccess } = usePlanRestrictions();
  
  // Protection supplémentaire : rediriger si pas d'accès
  useEffect(() => {
    if (!restrictions?.isAdmin && !checkAccess('tasks')) {
      navigate('/dashboard', { replace: true });
    }
  }, [restrictions, checkAccess, navigate]);
  
  if (!restrictions?.isAdmin && !checkAccess('tasks')) {
    return null; // Ne rien afficher pendant la redirection
  }
  
  return (
    <PageWrapper>
      <PageLayout title="Workboard">
        <ModernWorkboard />
      </PageLayout>
    </PageWrapper>
  );
};

export default WorkboardPage;
